const getRandomHsl = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

const tartans = [
  'hsl(145, 44%, 32%)',
  'hsl(45, 44%, 32%)',
  'hsl(245, 44%, 32%)',
  'hsl(345, 44%, 32%)',
  'hsl(145, 34%, 32%)',
  'hsl(45, 34%, 32%)',
  'hsl(245, 34%, 32%)',
  'hsl(345, 34%, 32%)',
  'hsl(145, 24%, 32%)',
  'hsl(45, 24%, 32%)',
  'hsl(245, 24%, 32%)',
  'hsl(345, 24%, 32%)',
  'hsl(145, 14%, 32%)',
  'hsl(45, 14%, 32%)',
  'hsl(245, 14%, 32%)',
  'hsl(345, 14%, 32%)',
  'hsl(145, 44%, 42%)',
  'hsl(45, 44%, 42%)',
  'hsl(245, 44%, 42%)',
  'hsl(345, 44%, 42%)',
  'hsl(145, 34%, 42%)',
  'hsl(45, 34%, 42%)',
  'hsl(245, 34%, 42%)',
  'hsl(345, 34%, 42%)',
  'hsl(145, 24%, 42%)',
  'hsl(45, 24%, 42%)',
  'hsl(245, 24%, 42%)',
  'hsl(345, 24%, 42%)',
  'hsl(145, 14%, 42%)',
  'hsl(45, 14%, 42%)',
  'hsl(245, 14%, 42%)',
  'hsl(345, 14%, 42%)',
  'hsl(145, 44%, 52%)',
  'hsl(45, 44%, 52%)',
  'hsl(245, 44%, 52%)',
  'hsl(345, 44%, 52%)',
  'hsl(145, 34%, 52%)',
  'hsl(45, 34%, 52%)',
  'hsl(245, 34%, 52%)',
  'hsl(345, 34%, 52%)',
  'hsl(145, 24%, 52%)',
  'hsl(45, 24%, 52%)',
  'hsl(245, 24%, 52%)',
  'hsl(345, 24%, 52%)',
  'hsl(145, 14%, 52%)',
  'hsl(45, 14%, 52%)',
  'hsl(245, 14%, 52%)',
  'hsl(345, 14%, 52%)',
  'hsl(145, 44%, 62%)',
  'hsl(45, 44%, 62%)',
  'hsl(245, 44%, 62%)',
  'hsl(345, 44%, 62%)',
  'hsl(145, 34%, 62%)',
  'hsl(45, 34%, 62%)',
  'hsl(245, 34%, 62%)',
  'hsl(345, 34%, 62%)',
  'hsl(145, 24%, 62%)',
  'hsl(45, 24%, 62%)',
  'hsl(245, 24%, 62%)',
  'hsl(345, 24%, 62%)',
  'hsl(145, 14%, 62%)',
  'hsl(45, 14%, 62%)',
  'hsl(245, 14%, 62%)',
  'hsl(345, 14%, 62%)',
  'hsl(145, 44%, 72%)',
  'hsl(45, 44%, 72%)',
  'hsl(245, 44%, 72%)',
  'hsl(345, 44%, 72%)',
  'hsl(145, 34%, 72%)',
  'hsl(45, 34%, 72%)',
  'hsl(245, 34%, 72%)',
  'hsl(345, 34%, 72%)',
  'hsl(145, 24%, 72%)',
  'hsl(45, 24%, 72%)',
  'hsl(245, 24%, 72%)',
  'hsl(345, 24%, 72%)',
  'hsl(145, 14%, 72%)',
  'hsl(45, 14%, 72%)',
  'hsl(245, 14%, 72%)',
  'hsl(345, 14%, 72%)'];

const randomTartan = tartans[Math.floor(Math.random() * tartans.length)];

export const getBackgroundTartan = () => ({
  background: `hsl( ${getRandomHsl(100, 255)}, ${getRandomHsl(30, 50)}%, ${getRandomHsl(30, 50)}%)`,
  width: '100%',
  'background-image': `repeating-linear-gradient(transparent, transparent 50px, rgba(0,0,0,.4) 50px, rgba(0,0,0,.4) 53px, transparent 53px, transparent 63px, rgba(0,0,0,.4) 63px, rgba(0,0,0,.4) 66px, transparent 66px, transparent 116px, rgba(0,0,0,.5) 116px, rgba(0,0,0,.5) 166px, rgba(255,255,255,.2) 166px, rgba(255,255,255,.2) 169px, rgba(0,0,0,.5) 169px, rgba(0,0,0,.5) 179px, rgba(255,255,255,.2) 179px, rgba(255,255,255,.2) 182px, rgba(0,0,0,.5) 182px, rgba(0,0,0,.5) 232px, transparent 232px),
    repeating-linear-gradient(270deg, transparent, transparent 50px, rgba(0,0,0,.4) 50px, rgba(0,0,0,.4) 53px, transparent 53px, transparent 63px, rgba(0,0,0,.4) 63px, rgba(0,0,0,.4) 66px, transparent 66px, transparent 116px, rgba(0,0,0,.5) 116px, rgba(0,0,0,.5) 166px, rgba(255,255,255,.2) 166px, rgba(255,255,255,.2) 169px, rgba(0,0,0,.5) 169px, rgba(0,0,0,.5) 179px, rgba(255,255,255,.2) 179px, rgba(255,255,255,.2) 182px, rgba(0,0,0,.5) 182px, rgba(0,0,0,.5) 232px, transparent 232px),
    repeating-linear-gradient(125deg, transparent, transparent 2px, rgba(0,0,0,.2) 2px, rgba(0,0,0,.2) 3px, transparent 3px, transparent 5px, rgba(0,0,0,.2) 5px)`,
});
export default getRandomHsl;
